<template>
  <div
      class="wrapper"
      id="app-wrapper"
      :class="[{'is-visible': true}]"
  >
    <statewide-main></statewide-main>
  </div>
</template>

<script>
/* eslint-disable */
import statewideMain from "@/views/statewide/statewide-main.vue";


export default {
  name: 'app',
  components: {
    statewideMain,
  },
  data: function () {
    return {}
  },
}
</script>


<style lang="scss">
@import "./styles/style-views";
@import './styles/style-components';
</style>

<style lang="scss">
.wrapper {
  visibility: hidden;
  opacity: 0;
  transition: opacity 100ms ease-out;
  transition-delay: 200ms;
}

.wrapper.is-visible,{
  visibility: visible;
  opacity: 1;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
